import {ToastType} from '../components/toasts/use-toasts'
import {BulkUpdateResources} from '../strings'

type BulkUpdateOutcome = {
  totalItemsUpdated: number
  totalItemsFailed: number
  skippedItemCount: number
}

export function getBulkUpdateToast({totalItemsUpdated, totalItemsFailed, skippedItemCount}: BulkUpdateOutcome): {
  type: ToastType
  message: string
} {
  const failedItemCount = skippedItemCount + totalItemsFailed
  const bulkUpdateFailed = totalItemsUpdated === 0 && failedItemCount > 0

  return {
    type: bulkUpdateFailed ? ToastType.error : ToastType.success,
    message: bulkUpdateFailed
      ? BulkUpdateResources.refreshPageMessage(failedItemCount)
      : BulkUpdateResources.successMessage(failedItemCount),
  }
}
